import React from "react";
import { Link } from "react-router-dom";
import { routes } from "../../constants/routes";
import { AuthService } from "../../services";
import RolePermission from "../../services/RolePermission";
import { AccountActionType, EventActionType } from "../../constants/Enum";

const AccountDashboard = () => {
  let loginUser = AuthService.getLoginUser();
  return (
    <React.Fragment>
      <section className="personl-info">
        <div className="container">
          <div className="row">
            {/******** Personal profile ************/}
            {RolePermission.isAccess(
              loginUser?.role,
              AccountActionType.PersonalProfile
            ) ? (
              <div className="col-sm-12 col-md-6 col-lg-4">
                <Link to={routes.ACCOUNT_PERSONALINFO}>
                  <div className="personl-info1">
                    <div className="personl-info2">
                      {/* <img src="/assets/images/info-icon1.png" alt="" /> */}
                      <img src="/assets/images/info-icon1gray.png" alt="" />
                      <img
                        src="/assets/images/info-icon1.png"
                        className="img-top"
                        alt="Card Front"
                      />
                    </div>
                    <div className="personl-info3">
                      <h5>Personal profile</h5>
                      <p>
                        Manage your personal details, including your name,
                        profile picture, and contact information used on Swallow
                        Events.
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : (
              <></>
            )}
            {/******** Business profile ************/}
            {RolePermission.isAccess(
              loginUser?.role,
              AccountActionType.BusinessProfile
            ) ? (
              <div className="col-sm-12 col-md-6 col-lg-4">
                <Link to={routes.ACCOUNT_BUSINESSINFO}>
                  <div className="personl-info1">
                    <div className="personl-info2">
                      <img src="/assets/images/info-icon2gray.png" alt="" />
                      <img
                        src="/assets/images/info-icon2.png"
                        alt=""
                        className="img-top"
                      />
                    </div>
                    <div className="personl-info3">
                      <h5>Business profile</h5>
                      <p>
                        Update your company details, logo, and business-related
                        information for transactions and visibility on Swallow
                        Events.
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : (
              <></>
            )}

            {/******** My events ************/}
            {RolePermission.isAccess(
              loginUser?.role,
              EventActionType.MyEventView
            ) ? (
              <div className="col-sm-12 col-md-6 col-lg-4">
                <Link to={routes.ACCOUNT_EVENTS}>
                  <div className="personl-info1">
                    <div className="personl-info2">
                      <img src="/assets/images/info-icon3gray.png" alt="" />
                      <img
                        src="/assets/images/info-icon3.png"
                        alt=""
                        className="img-top"
                      />
                    </div>
                    <div className="personl-info3">
                      <h5>My events</h5>
                      <p>
                        View and manage all your registered or hosted events,
                        including schedules, attendees, and updates
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : (
              <></>
            )}

            {/******** My Applications ************/}
            {RolePermission.isAccess(
              loginUser?.role,
              AccountActionType.ManageApplication
            ) ? (
              <div className="col-sm-12 col-md-6 col-lg-4">
                <Link to={routes.ACCOUNT_APPLICATIONS}>
                  <div className="personl-info1">
                    <div className="personl-info2">
                      <img src="/assets/images/info-icon2gray.png" alt="" />
                      <img
                        src="/assets/images/info-icon2.png"
                        alt=""
                        className="img-top"
                      />
                    </div>
                    <div className="personl-info3">
                      <h5>My Applications</h5>
                      <p>
                        View all of your event applications and up to date
                        application statuses
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : (
              <></>
            )}

            {/******** Subscription ************/}
            {RolePermission.isAccess(
              loginUser?.role,
              AccountActionType.ManageSubscription
            ) ? (
              <div className="col-sm-12 col-md-6 col-lg-4">
                <Link to={routes.ACCOUNT_ACTIVESUBSCRIPTIONP}>
                  <div className="personl-info1">
                    <div className="personl-info2">
                      <img src="/assets/images/info-icon4gray.png" alt=""></img>
                      <img
                        src="/assets/images/info-icon4.png"
                        alt=""
                        className="img-top"
                      />
                    </div>
                    <div className="personl-info3">
                      <h5>Subscription</h5>
                      <p>
                        {" "}
                        Check your subscription plan, renewal dates, and
                        available benefits for Swallow Events services.
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : (
              <></>
            )}

            {/******** Payments & payouts ************/}
            {RolePermission.isAccess(
              loginUser?.role,
              AccountActionType.Payout
            ) ? (
              <div className="col-sm-12 col-md-6 col-lg-4">
                <Link to={routes.ACCOUNT_MANAGE_PAYMENT}>
                  <div className="personl-info1">
                    <div className="personl-info2">
                      <img src="/assets/images/info-icon5gray.png" alt="" />
                      <img
                        src="/assets/images/info-icon5.png"
                        alt=""
                        className="img-top"
                      />
                    </div>
                    <div className="personl-info3">
                      <h5>Payments & payouts</h5>
                      <p>
                        Track your transactions, pending payments, and
                        withdrawal history in one place.
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : (
              <></>
            )}

            {/********Notifications************/}
            {RolePermission.isAccess(
              loginUser?.role,
              AccountActionType.Notifications
            ) ? (
              <div className="col-sm-12 col-md-6 col-lg-4">
                <Link to={routes.NOTIFICATION_LIST}>
                  <div className="personl-info1">
                    <div className="personl-info2">
                      <img src="/assets/images/info-icon6gray.png" alt="" />
                      <img
                        src="/assets/images/info-icon6.png"
                        alt=""
                        className="img-top"
                      />
                    </div>
                    <div className="personl-info3">
                      <h5>Notifications</h5>
                      <p>
                        Control your notification preferences and stay updated
                        on event changes, messages, and important alerts.
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : (
              <></>
            )}
            {/******** Manage Units ***********/}
            {RolePermission.isAccess(
              loginUser?.role,
              AccountActionType.ShopFront
            ) ? (
              <div className="col-sm-12 col-md-6 col-lg-4">
                <Link to={routes.TRADER_UNIT_LIST}>
                  <div className="personl-info1">
                    <div className="personl-info2">
                      <img src="/assets/images/unitsgray.png" alt="" />
                      <img
                        src="/assets/images/units.png"
                        alt=""
                        className="img-top"
                      />
                    </div>
                    <div className="personl-info3">
                      <h5>Shop Front-Manage your Units </h5>
                      <p>
                        Add your units, assign menus, upload all H&S
                        documentation to your individual units and enable single
                        click automated event applications with all of your
                        preloaded information
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : (
              <></>
            )}

            {/******** Shopfront ************/}
            {RolePermission.isAccess(
              loginUser?.role,
              AccountActionType.ShopFront
            ) ? (
              <div className="col-sm-12 col-md-6 col-lg-4">
                <Link to={routes.EVENT_SHOPFRONT_LIST}>
                  <div className="personl-info1">
                    <div className="personl-info2">
                      <img src="/assets/images/menu-productsgray.png" alt="" />
                      <img
                        src="/assets/images/menu-products.png"
                        alt=""
                        className="img-top"
                      />
                    </div>
                    <div className="personl-info3">
                      <h5>Manage your Menus & Products</h5>
                      <p>
                        Add your products, menus and images to your profile
                        which can be assigned to your Shop Front/Individual
                        units to enable single click, seamless event
                        applications
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : (
              <></>
            )}

            {/******** Messages ************/}
            {RolePermission.isAccess(
              loginUser?.role,
              AccountActionType.Messages
            ) ? (
              <div className="col-sm-12 col-md-6 col-lg-4">
                <Link to={routes.MESSAGE_INBOX}>
                  <div className="personl-info1">
                    <div className="personl-info2">
                      <img src="/assets/images/messenger_inactive.png" alt="" />
                      <img
                        src="/assets/images/messenger_active.png"
                        alt=""
                        className="img-top"
                      />
                    </div>
                    <div className="personl-info3">
                      <h5>Messages</h5>
                      <p>
                        Access your messages and conversations related to
                        events, bookings, and business interactions.
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : (
              <></>
            )}
            {/******** Reports ************/}
            {RolePermission.isAccess(
              loginUser?.role,
              AccountActionType.Reports
            ) ? (
              <div className="col-sm-12 col-md-6 col-lg-4">
                <Link to={routes.EVENT_REPORT_DASHBOARD}>
                  <div className="personl-info1">
                    <div className="personl-info2">
                      <img src="/assets/images/file-report.png" alt="" />
                      <img
                        src="/assets/images/file-report2.png"
                        alt=""
                        className="img-top"
                      />
                    </div>
                    <div className="personl-info3">
                      <h5>Reports</h5>
                      <p>
                        Generate and review reports on event performance,
                        payments, and engagement insights.
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default AccountDashboard;
